<template>
  <action-dialog
    ref="confirmationDialog"
    data-test-id="seat-chart-confirmation-dialog"
    :ok-label="$t('actions.confirm')"
    :cancel-label="$t('actions.cancel')"
    ok-color="positive"
    cancel-color="info"
    persistent
    buttons-inlined
    label-capitalize
    no-padding
    @ok="handleConfirmation()"
  >
    <template #custom-message>
      <div
        class="scroll"
        style="max-height: 70vh; overflow-y: auto;"
      >
        <div
          class="text-body1 text-left q-ma-lg"
          :class="{ 'q-px-md': $q.screen.gt.xs }"
        >
          <div
            style="white-space: pre-wrap;"
            v-html="message"
          />
          <q-btn
            v-if="expandInfo"
            flat
            padding="none"
            size="md"
            class="block q-mt-sm"
            @click="isExpanded = !isExpanded"
          >
            <span v-if="!isExpanded">{{ $t('nav.actions.readMore') }} <span class="material-icons"> expand_more</span></span>
            <span v-else>{{ $t('nav.actions.readLess') }} <span class="material-icons"> expand_less</span></span>
          </q-btn>
          <div
            v-if="isExpanded"
            style="white-space: pre-wrap;"
            v-html="expandInfo"
          />
        </div>
      </div>
      <div v-if="$q.screen.lt.sm">
        <q-checkbox
          v-model="doNotShowAgain"
          :class="{ 'q-ma-md': $q.screen.lt.sm }"
          color="primary"
          :label="$t('acknowledgment.doNotShowAgain')"
        />
      </div>
    </template>
    <template #buttons>
      <div
        v-if="$q.screen.gt.xs"
        class="col-auto"
      >
        <q-checkbox
          v-model="doNotShowAgain"
          color="primary"
          :label="$t('acknowledgment.doNotShowAgain')"
        />
      </div>
    </template>
  </action-dialog>
</template>

<script>
import { date } from 'quasar'
import ActionDialog from 'src/modules/consumer/components/ActionDialog'
const { addToDate } = date
export default {
  name: 'ConfirmationDialog',
  components: {
    ActionDialog
  },
  configuration: ['currentSite'],
  props: {
    message: {
      type: String,
      required: true
    },
    expandInfo: {
      type: String,
      required: false,
      default: null
    },
    seatChartId: {
      type: Number,
      required: false,
      default: null
    }
  },
  emits: ['confirmed'],
  data () {
    return {
      doNotShowAgain: false,
      shown: false,
      isExpanded: false
    }
  },
  methods: {
    show () {
      this.$refs.confirmationDialog.show()
    },
    hide () {
      this.$refs.confirmationDialog.hide()
    },
    handleConfirmation () {
      // Set localStorage to not show the dialog again
      if (this.doNotShowAgain) {
        const storageKey = this.$constants.localStorageKeys.seatChartConfirmations
        const existingConfirmations = JSON.parse(localStorage.getItem(storageKey) || '[]')

        const now = new Date()
        const validConfirmations = _.filter(
          existingConfirmations,
          conf => new Date(conf.expires) > now
        )
        const newConfirmation = {
          siteId: this.currentSite.id,
          content: {
            message: this.message,
            expandInfo: this.expandInfo || null,
            doNotShowAgain: true
          },
          seatChartId: this.seatChartId,
          expires: addToDate(new Date(), { date: 1 }) // expires in 1 day
        }
        // Skip adding if an identical confirmation already exists
        if (_.some(validConfirmations, (confirmation) => {
          return confirmation.siteId === newConfirmation.siteId &&
            confirmation.seatChartId === newConfirmation.seatChartId &&
            confirmation.content.message === newConfirmation.content.message &&
            confirmation.content.expandInfo === newConfirmation.content.expandInfo
        })) {
          return
        }

        // Add the new confirmation to the array
        const updatedConfirmations = [...validConfirmations, newConfirmation]

        localStorage.setItem(storageKey, JSON.stringify(updatedConfirmations))
      }
      this.$refs.confirmationDialog.hide()
      this.$emit('confirmed')
      // Reset the doNotShowAgain checkbox to false
      this.doNotShowAgain = false
    }
  }
}
</script>
